import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLocation, useRouteMatch } from 'react-router-dom';
import { Grid, IconButton, LinearProgress, Tooltip } from '@mui/material';
import ReadMoreIcon from '@mui/icons-material/ReadMore';

import './cmsUserList.css';
import { getDataList } from '../../../../helpers/getDataList';
import PageHeader from '../../includes/PageHeader';
import showMessage from '../../../../helpers/showMessage';
import { useSnackbar } from 'notistack';
import { Box } from '@mui/system';

export function CmsUserList() {
    const { pathname } = useLocation();

    const columns = [
        // {
        //     field: 'id',
        //     headerName: 'ID',
        //     // width: 90

        //     flex: 1,
        // },
        {
            field: 'name',
            headerName: 'Нэр',
            // width: 250,DESC
            flex: 1,
        },
        {
            field: 'email',
            headerName: 'И-мэйл',
            // width: 250,
            flex: 1,
        },
        {
            field: 'channel',
            headerName: 'ТВ',
            // width: 250,
            flex: 1,

            renderCell: (params) => {
                console.log(params);
                return <div>{params.value?.name}</div>;
            },
        },
        {
            field: 'role',
            headerName: 'Role',
            // width: 250,
            flex: 1,
        },
        {
            field: 'edit',
            headerName: 'Дэлгэрэнгүй',
            renderCell: (params) => {
                return (
                    <div>
                        <Link to={`${pathname}/${params.id}`}>
                            <Tooltip title="Засах">
                                <IconButton>
                                    <ReadMoreIcon />
                                </IconButton>
                            </Tooltip>
                        </Link>
                    </div>
                );
            },
            // width: 115,
            flex: 1,
        },
    ];

    const [isLoading, setIsLoading] = useState(true);
    const [cmsUserList, setCmsUserList] = useState([]);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        let isActive = true;

        getDataList('cms-users')
            .then((response) => {
                if (isActive) {
                    setCmsUserList(response.data?.data);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                const message = error.response?.data?.message
                    ? error.response.data.message
                    : error.message;
                showMessage(message, enqueueSnackbar, 'error');
            });

        return () => {
            isActive = false;
        };
    }, []);

    const { path } = useRouteMatch();
const localizedTextsMap = {
  columnMenuUnsort: "Ангилаагүй",
  columnMenuSortAsc: "Өсөхөөр эрэмблэх",
  columnMenuSortDesc: "Буурахаар эрэмблэх",
  columnMenuFilter: "Хайх",
  columnMenuHideColumn: "Нуух",
  columnMenuShowColumns: "Багана харах"
};
    return (
        <Grid
            container
            justifyContent="center"
            style={{ height: 630, width: '100%' }}
        >
            <PageHeader
                pageName="CMS Хэрэглэгчид"
                addNewLink={path + '/create'}
            />
            {isLoading ? (
                <Box sx={{ width: '100%' }}>
                    <LinearProgress />
                </Box>
            ) : (
                <DataGrid
                    rows={cmsUserList}
                    columns={columns}
                    pageSize={100}
                    rowsPerPageOptions={[10, 20, 30, 40, 50]}
                    checkboxSelection={false}
                        disableSelectionOnClick
                        localeText={localizedTextsMap}
                />
            )}
        </Grid>
    );
}
